import { createSlice } from '@reduxjs/toolkit';

export const userrolesSlice = createSlice({
  name: 'userroles',
  initialState: {
    value: []
  },
  reducers: {
    setUserRoles: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { setUserRoles } = userrolesSlice.actions;
export default userrolesSlice.reducer;
